// Sperren, Freigeben, Archivieren, Zurückholen, Löschen eines Vereins.
// Jede Funktion wirft bei einer Fehlerantwort; die Dialoge zeigen die Meldung am Knopf.
import { useMemo } from 'react';
import { apiJson } from './vereinHilfen';

export function useVereinAktionen() {
  return useMemo(() => ({
    sperren: (v, grund) => apiJson(`/api/vereine/${v.vereins_id}/status`, {
      method: 'PATCH', body: JSON.stringify({ status: 'gesperrt', grund: grund || null }),
    }),
    freigeben: (v) => apiJson(`/api/vereine/${v.vereins_id}/status`, {
      method: 'PATCH', body: JSON.stringify({ status: 'aktiv' }),
    }),
    archivieren: (v, grund) => apiJson(`/api/vereine/${v.vereins_id}/archive`, {
      method: 'POST', body: JSON.stringify({ grund: grund || 'ohne Angabe' }),
    }),
    zurueckholen: (a) => apiJson(`/api/vereine/archived/${a.archiv_id}/restore`, { method: 'POST' }),
    // Der Server vergleicht den eingetippten Namen noch einmal (bestaetigung).
    loeschen: (vereinsId, name) => apiJson(`/api/vereine/${vereinsId}/permanent`, {
      method: 'DELETE', body: JSON.stringify({ bestaetigung: name }),
    }),
  }), []);
}
